import {Injectable} from '@angular/core';
import {AuthService} from '../auth.service';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Observable, of} from 'rxjs';
import {catchError, map, switchMap, tap} from 'rxjs/operators';
import {Action} from '@ngrx/store';
import {
  AuthActions,
  LOAD_USER,
  LOGIN,
  LoginFailed,
  LoginFinished,
  SIGN_OUT,
  SIGN_UP,
  SIGN_UP_FINISHED,
  SignOutFinished,
  SignUpFailed,
  SignUpFinished
} from './authentication-actions';
import {Router} from '@angular/router';
import {UserService} from '../../user/services';
import {UserInfo} from 'firebase';
import {SharedToastService} from '../../shared/shared/toast.service';

@Injectable()
export class AuthenticationEffects {
  constructor(private actions$: Actions,
              private authService: AuthService,
              private toastService: SharedToastService,
              private userService: UserService, private router: Router) {
  }

  @Effect()
  register$: Observable<AuthActions> = this.actions$.pipe(
    ofType(SIGN_UP),
    map((action: any) => action.payload),
    switchMap((credentials: { email: string, displayName: string, password: string }) => {
        const result = this.authService.register(credentials.email, credentials.displayName, credentials.password)
        .pipe(
          map((user) => {
            console.log('mapping to sign up finished with user ', user);
            return new SignUpFinished(user);
          }),
          catchError((error) => this.handleSignupFailure(error)));
        result.subscribe((s) => console.log('result is ', s));
        console.log('result is ', result);
        return result;
      }
    )
  );

  @Effect()
  login$: Observable<AuthActions> = this.actions$.pipe(
    ofType(LOGIN),
    map((action: any) => action.payload),
    switchMap((credentials: { username: string, password: string }) => {
      return this.authService.login(credentials.username, credentials.password).pipe(
        tap((u: UserInfo) => this.toastService.info({msg: u.displayName + '!' , title: 'Welcome Back'})),
        map((u: UserInfo) => {
          console.log('login finish with ', u.photoURL);
          return new LoginFinished(u);
        }),
        catchError((error: any) => {

          if (error.code === 'auth/auth/network-request-failed') {
            return of(new LoginFailed('You appear to be offline'));
          } else {
            return of(new LoginFailed(error.message));
          }
        })
      );
    })
  );

  @Effect({dispatch: false})
  signUpSuccess$: Observable<Action> = this.actions$.pipe(
    ofType(SIGN_UP_FINISHED),
    tap(_ => {
      console.log('sign up finished here redirecting to success page');
      this.router.navigate(['registration-successful']);
    }),
  );

  @Effect()
  loadUser$: Observable<AuthActions> = this.actions$.pipe(
    ofType(LOAD_USER),
    switchMap((action) => {
      console.log('loading user');
      return this.authService.loadUser();
    }),
    map((user: UserInfo) => new LoginFinished(user))
    );

  @Effect()
  signOut$ = this.actions$.pipe(
    ofType(SIGN_OUT),
    tap((action) => {
      console.log('loging out');
      this.authService.signOut();
    }),
    tap(() => this.router.navigateByUrl('/')),
    tap(() => this.toastService.info({title: 'Good bye!', msg: 'See you later'})),
    map(() => new SignOutFinished()));

  handleSignupFailure(error: any) {
    console.log('handling signup error ', error);
    const errorCode = error.code;
    const errorMessage = error.message;
    if (errorCode === 'auth/weak-password') {
      return of(new SignUpFailed('The password is too weak.'));
    } else {
      return of(new SignUpFailed(errorMessage));
    }
  }
}
